export const Individual = 'individual';
export const SoleProprietor = 'sole-proprietor';
export const SingleMemberLLC = 'single-member-llc';
export const OtherEntity = 'other-entity';

export default {
    Individual,
    SoleProprietor,
    SingleMemberLLC,
    OtherEntity
}

